import React, { useMemo } from 'react';
import Chart from 'react-google-charts';
import Loading from '../ui/loading/Loading.js';

export default (props) => {
	const d = [['Task', 'Cost']].concat(Object.keys(props.data).map((x)=>[x, props.data[x]]));
	if (Object.keys(props.data).length === 0) return <p>No cost data found found.</p>;
	return <div className="CostsBarChart">
		<Chart
			chartType="ColumnChart"
			width="100%"
			height="100%"
			loader={<Loading />}
			data={d}
			options={{
				title: "Cost by Task",
				legend: {position: "none"},
				backgroundColor: { fill:'transparent' },
			}}
		/>
	</div>;
}